import { RootState } from 'redux/schemas';

export const getAIDiscussionPrompts = (state: RootState) => state.app.generatedAIContent.discussionPrompts;

export const getAIDiscussionInsights = (state: RootState, topicId: number) => state.app.generatedAIContent.discussionInsights[topicId];
